module.exports = __webpack_public_path__ + "media/images/ui__arrowDownInactive--dark-42ce2063a332b0d480ba1f3cdd369fb9.png";